<template>
  <div id="my-organisation reverse-mobile" class="row">
    <div class="col-12 col-md-3">
      <UserMenu></UserMenu>
    </div>
    <div class="col-12 col-md-9">
      <h3>My Organisation</h3>
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
export default {
  name: "MyOrganisation",
  components: {
    UserMenu
  }
};
</script>

<style scoped></style>
